import { Action } from 'gql/graphql';

type QuickLinkAccessInput = {
  name?: string;
  linkTo?: string | null;
};

const restrictedByLinkTo = new Set<string>([
  // Invite users/team members drawer
  'invite-drawer',
  // SNOW support case drawer entrypoint
  'create-ticket-drawer',
  // Go-live date drawer entrypoint
  'go-live-date-drawer',
]);

const restrictedByName = new Set<string>([
  // Deploy link naming has varied historically
  'SitecoreAI Deploy',
  'XM Cloud Deploy',
  // Support case naming has varied historically
  'Create support case',
  'Create support ticket',
  // Invite naming has varied historically (though linkTo should cover it)
  'Invite users',
  'Invite team members',
  // Go-live date naming
  'Add go-live date',
]);

export const hasQuickLinkAccess = (
  quickLink: QuickLinkAccessInput,
  hasOrgAdminOwnerAccess: boolean,
): boolean => {
  const { name, linkTo } = quickLink;
  const requiresAdminOwnerAccess =
    (!!linkTo && restrictedByLinkTo.has(linkTo)) ||
    (!!name && restrictedByName.has(name));

  return requiresAdminOwnerAccess ? hasOrgAdminOwnerAccess : true;
};

export const filterQuickLinksByRole = (
  quickLinks: Action[],
  hasOrgAdminOwnerAccess: boolean,
): Action[] => {
  return quickLinks.filter((quickLink) =>
    hasQuickLinkAccess(
      { name: quickLink.name, linkTo: quickLink.link?.to },
      hasOrgAdminOwnerAccess,
    ),
  );
};
